import { render } from "./DynamicMainComponent.vue?vue&type=template&id=353f12b4"
import script from "./DynamicMainComponent.vue?vue&type=script&lang=js"
export * from "./DynamicMainComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/u1042/tmp/bet-clipcut-003-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__